import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_vmy2cm353d: FaireBrandEntity = {
  token: "b_vmy2cm353d",
  type: "brand",
  name: "The Quiet Botanist",
  avatarUrl:
    "https://cdn.faire.com/fastly/ae299f352e223a198c87d3447539e8e219533cf86d19810530d223f819a14c97.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/9c289e3486fc19e08496a481af4a7b68eb4ccd6aacfdbf42d6dd8466f04cd6a8.png",
  logoUrl:
    "https://cdn.faire.com/fastly/ae299f352e223a198c87d3447539e8e219533cf86d19810530d223f819a14c97.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/9c289e3486fc19e08496a481af4a7b68eb4ccd6aacfdbf42d6dd8466f04cd6a8.png",
  location: "Hudson, NY, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 23,
  isTopShop: true,
  isInsider: true,
  description:
    "The Quiet Botanist was born out of a desire to slow down and listen. \n\nIt draws inspiration from apothecaries of a bygone era, wild-harvested Australian botanicals and overgrown European gardens. \n\nFounded by Rebecca O’Donnell a New York based award winning Creative Director. Originally from Sydney Australia, Rebecca created the brand out of a desire to slow down and be surrounded by beauty and the freedom to create every day.\n\nRebecca has always been a nature lover and constant gardener. The store was a place for her to heal from her chronic Lyme disease. This created a need to live a slower and calming life in which to heal or to live “the quiet life”.\n\nQuieting applies to life upstate in the country, as well as to urban areas and seeking a connection to nature no matter where you are in the world.\n\nThe range of products and services The Quiet Botanist offers hope to help carry this connection between nature, quieting and beauty.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:25.195Z",
    importedBy: "entity-db-cli",
  },
};
